import {CatalogConfig} from '../types'

// WP-6 — Loyalty member-balances (admin). A READ-ONLY, server-side projection of every member's
// loyalty point balance, rendered through the generic catalog screen using the WP-5 `serverSide`
// capability (all-members table → server sort / paginate / search / CSV). Not an editable catalog:
// the rows are computed from the ledger (balance = Sum(signed amount)), so writable is false and
// there is no soft-delete/status.
//
// BLOCKED: the all-members balances LIST endpoint below is NOT yet exposed on the backend. The
// ledger service (balance/stats) is merged+deployed, and per-member reads exist
// (loyalty-program/member/transactions/), but there is no members-with-balances list endpoint.
// This config targets the EXPECTED contract; verify against dev once the backend WP exposes it.
//
// Expected contract (admin-gated, djangorestframework_camel_case → camelCased keys):
//   GET /api/v1/loyalty-program/member-balances/
//     query:  limit, offset (LimitOffset), search (member name/email), ordering (DRF OrderingFilter
//             over: memberName, tier, balance, earned, redeemed, expiringSoon)
//     200:    { count, next, previous, results: [ {
//               id: <userId>, memberName, email, tier,
//               balance,        // current points = Sum(amount)
//               earned,         // Sum(amount) where type=earn
//               redeemed,       // Sum(|amount|) where type=redeem
//               expiringSoon    // points expiring within the next 30 days
//             } ] }
export const memberBalancesConfig: CatalogConfig = {
  slug: 'member-balances',
  endpoint: '/loyalty-program/member-balances/',
  titleId: 'CATALOG.MEMBER_BALANCES.TITLE',
  singularId: 'CATALOG.MEMBER_BALANCES.SINGULAR',
  primaryField: 'memberName',
  // Read-only computed projection: no create/edit, no soft-delete/status. Its own note (not the
  // default "maintained in Django admin", which would be misleading for a ledger projection).
  writable: false,
  readonlyNoteId: 'CATALOG.MEMBER_BALANCES.READONLY_NOTE',
  fields: [
    {
      name: 'memberName',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.MEMBER',
      type: 'text',
      showInTable: true,
      searchable: true,
    },
    {
      name: 'email',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.EMAIL',
      type: 'text',
      showInTable: true,
      searchable: true,
    },
    {name: 'tier', labelId: 'CATALOG.MEMBER_BALANCES.FIELD.TIER', type: 'text', showInTable: true},
    {
      name: 'balance',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.BALANCE',
      type: 'text',
      showInTable: true,
    },
    {
      name: 'earned',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.EARNED',
      type: 'text',
      showInTable: true,
    },
    {
      name: 'redeemed',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.REDEEMED',
      type: 'text',
      showInTable: true,
    },
    {
      name: 'expiringSoon',
      labelId: 'CATALOG.MEMBER_BALANCES.FIELD.EXPIRING_SOON',
      type: 'text',
      showInTable: true,
    },
  ],
  pageSize: 20,
  serverSide: {
    // Endpoint uses DRF's stock SearchFilter (?search=) + OrderingFilter (?ordering=) → defaults.
    sortableFields: ['memberName', 'tier', 'balance', 'earned', 'redeemed', 'expiringSoon'],
    // Highest balances first by default.
    defaultOrdering: '-balance',
    csvExport: true,
    // No statusParam: a balances projection has no active/inactive dimension.
  },
}
